module.exports = __webpack_public_path__ + "media/dance_song.f59c8a0f.mp3";